import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";

export class memberMessages {
	private memberBase:any = new memberPortal();
    dataUrl:any;
	initTables(): any {
		let _self = this;
		let messagesTable = $('#members--messages table');
		let tableOptions = {
			"processing" : true,
			"ajax" : {
				"url" : _self.dataUrl,
                cache: true,
                dataSrc : ''
			},
			"columns": [
				{ "data": "date" },
				{ "data": "notification" },
                {
                    "data": "",
                    "className": "dt-center delete_message",
                    "defaultContent": '<i class="fa fa-trash"/>',
                    "orderable": false
                }
			],
			"columnDefs": [
			  { "width": "500px", "targets": 1 }
			]
		  }

		// initiate table with options
		messagesTable.dataTable(tableOptions);
		$('.delete_message').click(function() {
            $('#messages--delete-popup .title').html('Do you want to clear all messages?');
            _self.onDeleteAction();
        });
        $('table').on('click', '.delete_message', function() {
            $('#messages--delete-popup .title').html('Are you sure you want to delete this message ?');
			_self.onDeleteAction();
		});
	}
    onDeleteAction() {
        $.magnificPopup.open({
            items: {
                src: '#messages--delete-popup'
            },
            type: 'inline',
            midClick: true,
            enableEscapeKey: false,
            showCloseBtn: false,
            closeOnBgClick: false,
            modal: true,
            callbacks: {
                open: function() {
                    var $content = $(this.content);
     
                    $content.on('click', '.msg-btn-confirm', function() {
                        $.magnificPopup.close();
                        //call api to delete the message
                        alert('Message deleted successfully!')
                    });
     
                    $content.on('click', '.msg-btn-cancel', function() {
                        $.magnificPopup.close();
                    });
                }
            }
        }, 0);
    }    
}

let scope:Element = document.querySelector('#members--messages');

if (scope) {
	try {
	let memberMessage = new memberMessages();
    let url;
    $(document).ready(function() {
        if (window.location.hostname === 'localhost') {
            url = '/dummy-data/lcpMessage.json';
           }
       else {
          url = ''; // yet to decide
       }
    });
    memberMessage.dataUrl = url;
	memberMessage.initTables();
	} catch(e) {console.error(e);}
}
